<mat-sidenav-container [hasBackdrop]="hasBackdrop()">
  <mat-sidenav
    #sidenav
    [mode]="mode()"
    [fixedInViewport]="fixedInViewport()"
    [position]="position()"
    [autoFocus]="true"
  >
    <div
      class="sidenav-header"
      [class.button-on-left]="closeButtonSide() === 'left'"
      [class.button-on-right]="closeButtonSide() === 'right'"
    >
      <ng-template #closeButton>
        @if (closeButtonMode() !== 'hidden') {
          <mulo-menu-toggle-button
            (clicked)="close()"
            state="open"
            [style.position]="closeButtonMode()"
            [closeIcon]="closeButtonIcon()"
          ></mulo-menu-toggle-button>
        }
      </ng-template>

      @if (closeButtonSide() === 'left') {
        <ng-container *ngTemplateOutlet="closeButton"></ng-container>
      }
      <ng-content select="[slot='mulo-brand'], mulo-brand"></ng-content>
      @if (closeButtonSide() === 'right') {
        <ng-container *ngTemplateOutlet="closeButton"></ng-container>
      }
    </div>

    @if (computedTemplate()) {
      <ng-container *ngTemplateOutlet="computedTemplate()"></ng-container>
    }
  </mat-sidenav>
</mat-sidenav-container>
